<template>
  <el-container>
    <el-aside style="width:210px" :class="{ asidewidth: isCollapse }">
      <!-- 左侧菜单组件 -->
      <menu-bar></menu-bar>
    </el-aside>
    <el-container>
      <el-header height="50px">
        <!-- 顶部导航组件 -->
        <header-bar></header-bar>
      </el-header>
      <el-main class="main-view">
        <!-- 组内容区域     路由 -->
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import MenuBar from "./menubar/index";
import HeaderBar from "./headerbar/index";
import { mapGetters } from "vuex";
export default {
  name: "Dashbar",
  components: { MenuBar, HeaderBar },
  computed: {
    ...mapGetters(["isCollapse", "userinfo", "permission_routes"])
  },
  data() {
    return {};
  },
  created() {
    this.setuserinfo();
  },
  methods: {
    /*
     **  @description 登录对账号的存储以及对token的判断
     **  @param {}
     **  @return
     **  @author shipingan
     */
    setuserinfo() {
      let userinfo = this.$router.history.current.query;
      if (JSON.stringify(userinfo) != "{}") {
        this.$store.dispatch("setUserData", userinfo);
      }
      if (this.userinfo.token == "") {
        window.location.href = "http://park.110c.net";
      } else {
        /*
         **  @description 账号登陆成功--获取用户信息
         **  @param {}
         **  @return
         **  @author shipingan
         */
        this.$router.push("/");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.el-container {
  height: 100%;
  .el-aside {
    background-color: rgb(84, 92, 100);
  }
  .el-container {
    .el-header {
      padding: 0;
      line-height: 50px;
      border-bottom: 1px solid rgb(221, 221, 221);
    }
    .main-view {
      padding: 0;
    }
  }
}
.asidewidth {
  width: 64px !important;
}
</style>
